import { Component, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { UserOptions } from 'jspdf-autotable';
import { DigiServiceService } from '../services/digi-service.service';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material'
import * as _ from 'lodash';

// Extend jsPDF interface for autoTable
interface jsPDFWithPlugin extends jsPDF {
  setFontSize(arg0: number): unknown;
  text(arg0: string, arg1: number, arg2: any): unknown;
  save(arg0: string): unknown;
  autoTable: (options: UserOptions) => jsPDF;
}

@Component({
  selector: 'app-digi-report-popup',
  templateUrl: './digi-report-popup.component.html',
  styleUrls: ['./digi-report-popup.component.scss']
})
export class DigiReportPopupComponent implements OnInit {

  reportColumns:any;
  dataSource!: MatTableDataSource<any>;
  reportSummary: any = {};
  isDownloading: boolean = false;
  selectedGraphTab: number = 0;
  selectedGraphName: string = 'Fuel Level';
  selectedMainTab: number = 0; // Track main tab (0 = Graph, 1 = Report)

  // Chart data mapping for downloads
  graphDataMap: { [key: string]: any } = {};

  // Dummy graph data for all parameters
  fuelChart: any[] = []; fuelLayout: any = {};
  rpmChart: any[] = []; rpmLayout: any = {};
  oilChart: any[] = []; oilLayout: any = {};
  l1Chart: any[] = []; l1Layout: any = {};
  l2Chart: any[] = []; l2Layout: any = {};
  l3Chart: any[] = []; l3Layout: any = {};
  l1l2Chart: any[] = []; l1l2Layout: any = {};
  l2l3Chart: any[] = []; l2l3Layout: any = {};
  l3l1Chart: any[] = []; l3l1Layout: any = {};
  l1CurrentChart: any[] = []; l1CurrentLayout: any = {};
  l2CurrentChart: any[] = []; l2CurrentLayout: any = {};
  l3CurrentChart: any[] = []; l3CurrentLayout: any = {};
  pfChart: any[] = []; pfLayout: any = {};
  kwChart: any[] = []; kwLayout: any = {};
  kvaChart: any[] = []; kvaLayout: any = {};
  kvarChart: any[] = []; kvarLayout: any = {};
  kwhChart: any[] = []; kwhLayout: any = {};
  kvarhChart: any[] = []; kvarhLayout: any = {};
  kvahChart: any[] = []; kvahLayout: any = {};
  currentUserData = JSON.parse(localStorage.getItem('userData'));
  generatorIds: any;
  selectedDevice: any;
  timeFilter: any;
  timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
  customeSelectedDate: any;
  selectedFilter: any;
  keys: string[] = [];

  selectedKey = '';
  chartData: any[] = [];
  chartLayout: any = {};

  // group definitions
  groups = {
    current: { keys: ['L1_Current', 'L2_Current', 'L3_Current'], label: 'Current (A)' },
    voltage: { keys: ['L1_Voltage', 'L2_Voltage', 'L3_Voltage'], label: 'Voltage (V)' },
    phase: { keys: ['L1L2_Voltage', 'L2L3_Voltage', 'L3L1_Voltage'], label: 'Phase Voltage (V)' }
  };

@ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  generatorInfo: any;
  TotalKw:any;
  totalHours: any;
  rawData: any;
  constructor(private digiService:DigiServiceService,private matDialog: MatDialog) { }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngOnInit(): void {
    this.getDigiIds();
    this.timeFilter = 'Today';
  }
  getDigiIds(){
    this.digiService.getDigiIds({userid:this.currentUserData.userid}).subscribe(resp=>{
      if(resp.status){
        this.generatorIds = resp.result;
        this.selectedDevice = resp.result[0]
        this.filters('Today');

        console.log("gebnerators id",this.selectedDevice)
      }
    })
  }
  onDeviceSelect(device: any) {
    this.selectedDevice = device;
this.filters(this.selectedFilter.duration);
  }
  filters(duration:any){
    
      if (duration == "Custom") {
        let dialogRef = this.matDialog.open(CustomDateComponent, {
          autoFocus: false,
          height: '350px', width: '450px', data: { "details": "", "action": "Add",selectedDate:this.customeSelectedDate}
      });


      dialogRef.afterClosed().subscribe(value => {
        console.log("Value======= ", value);
        if (value) {
          this.selectedFilter = {...value,duration: duration,deviceid:this.selectedDevice.deviceid}
          this.customeSelectedDate = value;
        }
        this.getReportData(this.selectedFilter)
        this.getDeviceInfo(this.selectedDevice.deviceid)
      });
      } else{
        this.selectedFilter = {duration:duration,deviceid:this.selectedDevice.deviceid};
        this.getReportData(this.selectedFilter)
        this.getDeviceInfo(this.selectedDevice.deviceid)
      }

  }
  getReportData(filter){
    console.log(filter)
    this.dataSource =new MatTableDataSource([]);
    this.digiService.getReportData(filter).subscribe(res=>{
      if(res.status){
        this.reportColumns = res.columns;
        this.TotalKw= (Number(res.result[res.result.length-1].KWH- res.result[0].KWH)/1000).toFixed(2)
        //this.TotalKw = _.sumBy(res.result, 'Total_KW').toFixed(2);
        this.totalHours = this.calculateRunningHours(res.result)
        this.rawData = res.result;
        this.dataSource = new MatTableDataSource(res.result);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.keys = Object.keys(this.rawData[0]).filter(k => !['Date','Deviceid','L1_Current', 'L2_Current', 'L3_Current',
        'L1_Voltage', 'L2_Voltage', 'L3_Voltage',
        'L1L2_Voltage', 'L2L3_Voltage', 'L3L1_Voltage'].includes(k));
        this.keys.push('Current');
        this.keys.push('Voltage');
        this.keys.push('Phase Voltage');
        this.selectedKey = this.keys[0]; // default first key
        this.loadChart(this.selectedKey);
        console.log("what is data",res)
      } else {
        this.dataSource =new MatTableDataSource([]);
      }
    })
  }
  loadChart(key: string) {
    let traces = [];

    if (key === 'Current') {
      traces = this.createMultiTrace(['L1_Current', 'L2_Current', 'L3_Current'], 'Current (A)');
    } else if (key === 'Voltage') {
      traces = this.createMultiTrace(['L1_Voltage', 'L2_Voltage', 'L3_Voltage'], 'Voltage (V)');
    } else if (key === 'Phase Voltage') {
      traces = this.createMultiTrace(['L1L2_Voltage', 'L2L3_Voltage', 'L3L1_Voltage'], 'Phase Voltage (V)');
    } else {
      traces = [{
        x: this.rawData.map(d => d.Date),
        y: this.rawData.map(d => d[key]),
        type: 'scatter',
        mode: 'lines+markers',
        name: key
      }];
    }

    this.chartData = traces;
    this.chartLayout = {
      title: { text: key, x: 0.05, font: { size: 18 } },
      autosize: true,
      xaxis: { title: 'Time' },
      yaxis: { title: 'Value' },
      legend: {
        orientation: 'v',
        yanchor: 'top',
        y: 1,
        xanchor: 'left',
        x: 1.02,
        bgcolor: 'rgba(255,255,255,0.8)',
        bordercolor: '#ddd',
        borderwidth: 1,
        font: { size: 12, color: '#333' }
      },
      margin: { l: 60, r: 150, t: 50, b: 50 } // reserve space for right legend
    };
    
    
  }

  createMultiTrace(params: string[], label: string) {
    // Define color palette for up to 3 traces
    const colors = ['red', 'yellow', 'blue'];
  
    return params.map((param, index) => ({
      x: this.rawData.map(d => d.Date),
      y: this.rawData.map(d => d[param]),
      type: 'scatter',
      mode: 'lines+markers+text',
      name: param,
      line: { color: colors[index % colors.length], width: 2 },
      marker: { color: colors[index % colors.length], size: 6 }
    }));
  }
  
  


  formatLabel(key: string): string {
    return key.replace(/_/g, ' ');
  }

 calculateRunningHours(data: any): number {
    if (!data.length) return 0;
  
    // Sort logs by date
    const sortedData = data.sort(
      (a, b) => new Date(a.Date).getTime() - new Date(b.Date).getTime()
    );
  
    let totalMinutes = 0;
  
    for (let i = 1; i < sortedData.length; i++) {
      const prev = sortedData[i - 1];
      const curr = sortedData[i];
  
      const diffMs = new Date(curr.Date).getTime() - new Date(prev.Date).getTime();
      const diffMinutes = diffMs / (1000 * 60);
  
      // Generator ON if KW > 0
      const prevRunning = prev.Total_KW > 0;
      const currRunning = curr.Total_KW > 0;
  
      // If both running and gap <= 5 minutes, add to running time
      if (prevRunning && currRunning && diffMinutes <= 20) {
        totalMinutes += diffMinutes;
      }
    }
  
    return parseFloat((totalMinutes / 60).toFixed(2)); // hours
  }
  
  getDeviceInfo(deviceid){
    this.digiService.getGeneratorByDeviceid({deviceid:deviceid}).subscribe(res=>{
      if(res.status){
        console.log("Device Info",res.result)
        this.generatorInfo =res.result;
      }
    })
  }
  private avg(arr: number[]): number {
    return arr.length ? arr.reduce((a,b)=>a+b,0)/arr.length : 0;
  }

 


}